import { BaseMessageConfig } from '@/shared/types/message';

/**
 * Valores iniciales del toast antes de cualquier `configure` / `configureMessage` en runtime.
 */
export const defaultMessageConfig: BaseMessageConfig = {
  duration: 5000,
  maxMessages: 5,
  position: 'bottom-right',
  variant: 'outlined',
  primaryButtonText: 'Aceptar',
  secondaryButtonText: 'Cancelar',
  animationDuration: 300,
  size: 'sm',
};

/**
 * Configuración mutable de toasts; `MessageService.configure` y `configureMessage` la fusionan.
 */
export let messageConfig: BaseMessageConfig = { ...defaultMessageConfig };

/**
 * Actualiza la configuración global de toasts (duración máxima, posición por defecto, textos de botones, etc.).
 *
 * @param newConfig - Parcial fusionado sobre `messageConfig` actual.
 */
export const configureMessage = (newConfig: Partial<BaseMessageConfig>) => {
  messageConfig = { ...messageConfig, ...newConfig };
};
